import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import { useThemeContext } from "@/contexts/ThemeContext";

export default function UserInfoView({
  goBack,
  user,
  onChange,
  submit,
  isDisabled,
}: PropsView) {
  const { themeName } = useThemeContext();
  const title = themeName === 'zapay' ? 'Pedágio' : 'Dados Pessoais';

  return (
    <div className="h-full">
      <Header
        title={title}
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Seus dados pessoais</h2>
            <div className="flex flex-col justify-center items-center">
              <InputMask 
                value={user?.document as string}
                name="document"
                required 
                onChange={onChange} 
                type="text"
                inputMode="numeric"
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                placeholder="CPF"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input 
                value={user?.name as string}
                required 
                onChange={onChange} 
                type="text" 
                name="name" 
                placeholder="Nome completo" 
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <InputMask 
                value={user?.phone as string}
                name="phone"
                required 
                onChange={onChange} 
                type="text"
                inputMode="numeric"
                mask="(__) _____-____"
                replacement={{ _: /\d/ }}
                placeholder="Celular"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input 
                value={user?.email as string}
                required 
                onChange={onChange} 
                type="text" 
                inputMode="email"
                name="email" 
                placeholder="E-mail"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14" 
              />
            </div>
          </div>
          <Button 
            title="Avançar"
            onClick={submit}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </main>
    </div>
  );
}
